/**
 * Font variants
 */
import { FontWeight } from 'theme/fonts';

export const fontWeights: Record<App.Theme.Font.FontWeightType, App.Theme.Font.FontProps> = {
  regular: { fontWeight: FontWeight.regular },
  medium: { fontWeight: FontWeight.medium },
  bold: { fontWeight: FontWeight.bold },
  light: { fontWeight: FontWeight.light },
  black: { fontWeight: FontWeight.black },
  thin: { fontWeight: FontWeight.thin },
};
